var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20.57"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Header - Opt 1 (Grey)"
  }, /*#__PURE__*/React.createElement(Path, {
    "data-name": "Arrow 1",
    fill: "#fff",
    d: "M10.29 20.57L0 10.29 10.29 0 12 1.72l-8.57 8.57L12 18.86l-1.71 1.71z"
  }))));
}
export default SvgChevronLeft;